module.exports = __webpack_public_path__ + "img/badge-fastest-conversion-gold.937b86cd.png";